import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=a63fd590&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=a63fd590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63fd590",
  null
  
)

export default component.exports